const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('flarum-mentions', 'forum/mentionables/MentionableModel');